import React, { useContext } from "react";
import { useNavigate } from "react-router-dom";
import { useAuthProvider, PortalConfig, callApi, translateNamespace, usePluginProvider, DataContext, Loader } from "@cloudpremise/portal_core";
import MDBox from "@cloudpremise/portal_core/src/themes/mui/components/MDBox";
import DashboardLayout from "@cloudpremise/portal_core/src/themes/mui/examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "@cloudpremise/portal_core/src/themes/mui/examples/Navbars/DashboardNavbar";
import MDTypography from "@cloudpremise/portal_core/src/themes/mui/components/MDTypography";
import { useMaterialUIController } from "@cloudpremise/portal_core/src/themes/mui/context";
import MDInput from "@cloudpremise/portal_core/src/themes/mui/components/MDInput";
import MDButton from "@cloudpremise/portal_core/src/themes/mui/components/MDButton";

// @mui material components
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import Switch from "@mui/material/Switch";

const GlobalSettings = (props) => {
    const dataProvider = useContext(DataContext);
    const pluginManager = usePluginProvider();
    const [ authorized, authType, token ] = useAuthProvider();
    const [ controller, dispatch ] = useMaterialUIController();
    const { config, user } = controller;
    let portalConfig = {};
    if(config && config.hasOwnProperty("portalConfig")){
        portalConfig = config.portalConfig;
    }
    const defaultState = {
        maintenanceMode: false,
        maintenanceImageUrl: "",
        maintenanceMessage: "",
        allowBypass: false,
        banner: false,
        bannerText: "We are performing scheduled maintenance on 01/25/2024. We should be back online shortly after the maintenance.",
        bannerColor: "#FFAB00",
        textColor: "#000000",
        bannerCanClose: true,
        bannerTimeOn: "2025-01-20 11:58:00",
        bannerTimeOff: "2025-01-22 11:58:00",
        allowBundleDomain: true,
        proteusLeadObject: "sfLead",
        saving: false,
        ...portalConfig
    }
    const [state, setState] = React.useReducer((state: any, newState: Partial<any>) => ({
        ...state,
        ...newState
    }), defaultState);
    const navigate = useNavigate();
    React.useEffect(() => {
        if(!authorized){
            return navigate("/landing", { replace: true });
        }
    });

    function handleChange(e, name){
        setState({
            ...state,
            [name]: e.target.value,
        });
    }
    function handleCheckbox(e, name){
        setState({
            ...state,
            [name]: e.target.checked,
        });
    }
    function onSubmit(event){
        event.preventDefault();
        const requestData = {
            maintenanceMode: state.maintenanceMode,
            maintenanceImageUrl: state.maintenanceImageUrl,
            maintenanceMessage: state.maintenanceMessage,
            allowBypass: state.allowBypass,
            banner: state.banner,
            bannerText: state.bannerText,
            bannerColor: state.bannerColor,
            textColor: state.textColor,
            bannerCanClose: state.bannerCanClose,
            bannerTimeOn: state.bannerTimeOn,
            bannerTimeOff: state.bannerTimeOff,
            // allowBundleDomain: state.allowBundleDomain,
            proteusLeadObject: state.proteusLeadObject
        }

        let headers = {};
        let method = 'POST';
        let route = '/v1/portal/config/global';
        const portalConfigRecord: PortalConfig = {
            sObjectTypeName: 'Config',
            url: route,
            method: method,
            data: requestData,
            headers: headers
        }
        callApi(dataProvider, portalConfigRecord).then((response: any) => {
            setState({
                saving: false,
            });
            // if(response && Array.isArray(response?.result)){
            //     if(response.result.length > 0){
            //         const config = translateNamespace(response.result[0]);
            //         pluginManager.setConfiguredPlugins(config.plugins);
            //         dispatch({value: {config: config, loadingConfig: false}, type: "UPDATE_STATE"});
            //     }else{
            //         dispatch({value: {loadingConfig: false}, type: "UPDATE_STATE"});
            //     }
            // }else{
            //     dispatch({value: {loadingConfig: false}, type: "UPDATE_STATE"});
            // }
        }).catch((err) => {
            setState({
                saving: false,
            });
            console.log(err);
        });

        setState({
            saving: true,
        });
    }
    if(!authorized || !user.superAdmin){
        return null;
    }
    return (
        <MDBox>
            <Card>
                <MDBox p={2}>
                    <MDTypography component="h5" variant="h5" fontWeight="bold" color="dark" mb={3}>
                        Maintenance Mode
                    </MDTypography>
                    <Grid container spacing={3}>
                        <Grid item xs={12} md={6} lg={6}>
                            <MDBox
                                display="flex"
                                justifyContent="space-between"
                                alignItems="center"
                                width={{ xs: "100%", sm: "100%" }}
                            >
                                <MDBox lineHeight={0}>
                                    <MDTypography variant="button" color="text">
                                        {state.maintenanceMode ? "Enabled" : "Disabled"}{" Maintenance Mode"}
                                    </MDTypography>
                                </MDBox>
                                <MDBox mr={1}>
                                    <Switch checked={state.maintenanceMode} onChange={(event) => handleCheckbox(event, 'maintenanceMode')} />
                                </MDBox>
                            </MDBox>
                        </Grid>
                        <Grid item xs={12} md={6} lg={6}>
                            <MDInput
                                name="maintenanceImageUrl"
                                type="text"
                                label="Image URL"
                                placeholder="Image URL to show while in maintenance"
                                fullWidth
                                value={state.maintenanceImageUrl}
                                onChange={(e) => handleChange(e, "maintenanceImageUrl")}
                                required
                            />
                        </Grid>
                        <Grid item xs={12} md={12} lg={12}>
                            <MDInput
                                name="maintenanceMessage"
                                type="text"
                                label="Maintenance Message"
                                placeholder="Explain what's happening to your users..."
                                fullWidth
                                value={state.maintenanceMessage}
                                onChange={(e) => handleChange(e, "maintenanceMessage")}
                                required
                                multiline
                                rows={3}
                            />
                        </Grid>
                        <Grid item xs={12} md={12} lg={12}>
                            <MDBox
                                display="flex"
                                justifyContent="space-between"
                                alignItems="center"
                                width={{ xs: "100%", sm: "100%" }}
                            >
                                <MDBox lineHeight={0}>
                                    <MDTypography variant="button" color="text">
                                        Allow user to bypass with OK
                                    </MDTypography>
                                </MDBox>
                                <MDBox mr={1}>
                                    <Switch checked={state.allowBypass} onChange={(event) => handleCheckbox(event, 'allowBypass')} />
                                </MDBox>
                            </MDBox>
                        </Grid>
                    </Grid>
                </MDBox>
                <MDBox p={2}>
                    <MDTypography component="h5" variant="h5" fontWeight="bold" color="dark" mb={3}>
                        Banner Mode
                    </MDTypography>
                    <Grid container spacing={3}>
                        <Grid item xs={12} md={6} lg={6}>
                            <MDBox
                                display="flex"
                                justifyContent="space-between"
                                alignItems="center"
                                width={{ xs: "100%", sm: "100%" }}
                            >
                                <MDBox lineHeight={0}>
                                    <MDTypography variant="button" color="text">
                                        {state.banner ? "Enabled" : "Disabled"}{" Banner Mode"}
                                    </MDTypography>
                                </MDBox>
                                <MDBox mr={1}>
                                    <Switch checked={state.banner} onChange={(event) => handleCheckbox(event, 'banner')} />
                                </MDBox>
                            </MDBox>
                        </Grid>
                        <Grid item xs={12} md={12} lg={12}>
                            <MDInput
                                name="bannerText"
                                type="text"
                                label="Banner Message"
                                placeholder="Banner message here..."
                                fullWidth
                                value={state.bannerText}
                                onChange={(e) => handleChange(e, "bannerText")}
                                required
                                multiline
                                rows={3}
                            />
                        </Grid>
                        <Grid item xs={12} md={6} lg={6}>
                            <MDInput
                                name="bannerColor"
                                type="text"
                                label="Banner Style"
                                placeholder="Banner style: info, warning, success..."
                                fullWidth
                                value={state.bannerColor}
                                onChange={(e) => handleChange(e, "bannerColor")}
                                required
                            />
                        </Grid>
                        <Grid item xs={12} md={6} lg={6}>
                            <MDBox
                                display="flex"
                                justifyContent="space-between"
                                alignItems="center"
                                width={{ xs: "100%", sm: "100%" }}
                            >
                                <MDBox lineHeight={0}>
                                    <MDTypography variant="button" color="text">
                                        Allow user to close banner
                                    </MDTypography>
                                </MDBox>
                                <MDBox mr={1}>
                                    <Switch checked={state.bannerCanClose} onChange={(event) => handleCheckbox(event, 'bannerCanClose')} />
                                </MDBox>
                            </MDBox>
                        </Grid>
                    </Grid>
                    <MDBox mt={2}>
                        <MDButton variant="contained" color="dark" onClick={(event) => onSubmit(event)}>
                            {
                                state.saving ?
                                    <Loader color="white" size={20} />
                                :
                                    "Save Settings"
                            }
                        </MDButton>
                    </MDBox>
                </MDBox>
            </Card>
        </MDBox>
    )
}

export default GlobalSettings;